import { payrollApi } from 'Api/payroll';
import useDebounce from 'components/Global/Hooks/UseDebounce';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import dayjs from 'dayjs';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toastText } from 'utils/utils';
import PayrollHeader from './Header';
import PayrollTable from './Table';
const PayrollOverview = () => {
	const navigate = useNavigate();

	const [searchValue, setSearchValue] = useState('');
	const [currency, setCurrency] = useState('');
	const [statusFilterValue, setStatusFilterValue] = useState('');
	const [yearFilterValue, setYearFilterValue] = useState<any>(dayjs());
	const [payPeriodFilterValue, setPayPeriodFilterValue] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [sortOrder, setSortOrder] = useState('');
	const [totalRecords, setTotalRecords] = useState(0);
	const [payrollData, setPayrollData] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [deletePayrollId, setDeletePayrollId] = useState<string | null>(null);
	// const [isResponseLoading, setIsResponseLoading] = useState<boolean>(false);

	const handleSearch = (value: string) => {
		setSearchValue(value);
		setCurrentPage(1);
	};

	const debounceSearch = useDebounce(searchValue, 500);

	const handleCurrency = (value: string) => {
		setCurrency(value);
		setCurrentPage(1);
	};

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		setSortOrder(
			sorter?.order === 'ascend' ? 'asc' : sorter?.order ? 'desc' : ''
		);
		setSortField(sorter.field);
	};

	const handleStatusFilter = (value: string) => {
		setStatusFilterValue(value);
		setCurrentPage(1);
	};

	const handleYear = (value: any) => {
		setYearFilterValue(value);
		setCurrentPage(1);
		setPayPeriodFilterValue('');
	};

	const handlePayPeriod = (value: string) => {
		setPayPeriodFilterValue(value);
		setCurrentPage(1);
	};

	const handleSearchApi = async (value: string) => {
		//search api
	};

	const buttons = [
		{
			text: 'Run Payroll',
			isLoading: false,
			className: 'btn-blue',
			minWidth: '70px',
			isSubmit: true,
			onclick: () => {
				navigate('/run-payroll');
			},
			disabled: false,
		},
	];

	const fetchAllPayrolls = async () => {
		try {
			const query = {
				page: currentPage,
				search: debounceSearch.trim(),
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
				status: statusFilterValue,
				payPeriodId: payPeriodFilterValue,
				payYear: new Date(yearFilterValue).getFullYear(),
				payCurrency: currency,
			};
			setIsLoading(true);
			const response = await payrollApi.payrollOverview(query);
			setPayrollData(response.data.data.data);
			setTotalRecords(response.data.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching payroll data';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const showModal = () => {
		setIsModalOpen(true);
		///	setDeletePayrollId(null);
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setDeletePayrollId(null);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setDeletePayrollId(null);
	};

	const deleteHandler = async () => {
		if (deletePayrollId) {
			try {
				setIsDeleteLoading(true);
				await payrollApi.deletePayroll(deletePayrollId);
				handleCancel();
				fetchAllPayrolls();
				toastText('Payroll deleted successfully', 'success');
			} catch (error: any) {
				let message =
					error?.response?.data?.message ||
					`Something went wrong in delete payroll`;
				toastText(message, 'error');
			} finally {
				setIsDeleteLoading(false);
			}
		}
	};

	useEffect(() => {
		fetchAllPayrolls();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		currentPage,
		pageSize,
		debounceSearch,
		statusFilterValue,
		currency,
		sortOrder,
		sortField,
		yearFilterValue,
		payPeriodFilterValue,
	]);

	return (
		<>
			<PayrollHeader
				searchText={searchValue}
				handleSearch={handleSearch}
				handleSearchApi={handleSearchApi}
				StatusFilter={statusFilterValue}
				handleStatusFilter={handleStatusFilter}
				YearFilterValue={yearFilterValue}
				handleYear={handleYear}
				PayPeriodFilterValue={payPeriodFilterValue}
				handlePayPeriod={handlePayPeriod}
				currencyValue={currency}
				handleCurrency={handleCurrency}
				button={buttons}
				fetchAllPayrolls={fetchAllPayrolls}
				isLoading={isLoading}
			/>
			<div>
				<PayrollTable
					tableData={payrollData}
					totalRecords={totalRecords}
					currentPage={currentPage}
					pageSize={pageSize}
					isLoading={isLoading}
					tableChangeHandler={tableChangeHandler}
					showDeleteModal={showModal}
					setDeletePayroll={setDeletePayrollId}
					fetchAllPayrolls={fetchAllPayrolls}
				/>
			</div>
			<ConfirmDelete
				isModalOpen={isModalOpen}
				handleCancel={handleCancel}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading}
				handleOk={handleOk}
			/>
		</>
	);
};

export default PayrollOverview;
